import React from 'react'
import type { FogOfWar } from '@warcarp/api-types'
import { CompactOptionSelector } from './CompactOptionSelector'
import type { SetupLayout } from './setup/SetupControls'

type SetupFieldProps = { layout?: SetupLayout; changed?: boolean; disabled?: boolean; note?: string | null; noteTone?: 'muted' | 'warn'; separated?: boolean }

export const FOG_OF_WAR_OPTIONS: ReadonlyArray<{ value: FogOfWar; label: string }> = [
  { value: 'none', label: 'None' },
  { value: 'light', label: 'Light' },
  { value: 'heavy', label: 'Heavy' },
]

/** Setup control for fog of war (docs/fog-of-war/README.md). */
export function FogOfWarSelector({ value, onChange, ...field }: { value: FogOfWar; onChange: (fog: FogOfWar) => void } & SetupFieldProps) {
  return <CompactOptionSelector
    {...field}
    title="Fog of war"
    value={value}
    options={FOG_OF_WAR_OPTIONS}
    onChange={onChange}
    pillTestID="fog-of-war-selector"
    optionTestID={fog => `fog-of-war-${fog}`}
    helpLabel="What is fog of war?"
    helpMessage={[
      'You see troops and owners only on your own territories and everything you can attack from them, including across sea routes and from watchtowers.',
      "Light fog: everyone's colours show on every territory, but troop counts outside your view are hidden.",
      'Heavy fog: nothing outside your view, not even who owns it. Territories are always dealt at random.',
      "Other players' troop totals and cards are hidden, and moves you can't see show in the log as \"made a move in the fog\". The fog lifts when the game ends. Bots play by the same fog: they only know what their side has seen.",
    ]}
  />
}
